import * as z from "zod";

export const reviewReasonSchema = z.strictObject({
	reason: z.string(),
	active: z.boolean(),
	properties: z.array(z.string()),
	description: z.string(),
});
export type ReviewReasonItem = z.infer<typeof reviewReasonSchema>;
